'use client';

import { FC, ReactNode, AnchorHTMLAttributes } from 'react';
import { StyledLink } from './styles';

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: ReactNode;
  icon?: ReactNode;
}

export const Link: FC<LinkProps> = ({ href, children, icon, ...props }) => {
  return (
    <StyledLink href={href} {...props}>
      {icon}
      {children}
    </StyledLink>
  );
};
